import { render, staticRenderFns } from "./HighlightOilMakerStats.vue?vue&type=template&id=6935afcf&scoped=true"
import script from "./HighlightOilMakerStats.vue?vue&type=script&lang=js"
export * from "./HighlightOilMakerStats.vue?vue&type=script&lang=js"
import style0 from "./HighlightOilMakerStats.vue?vue&type=style&index=0&id=6935afcf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6935afcf",
  null
  
)

export default component.exports